import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { TabsSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { McvEmbeddedHandShearVaneWorksheet } from 'Components/Worksheets/HandShearVaneWorksheet';
import { useSelector } from 'react-redux';
import HandShearVaneResultsSection from './HandShearVaneResultsSection';

let HandShearVaneTabsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const tests = useSelector(createWorksheetSelector!('EmbeddedTests.Tests')) as any[];

  return (
    <TabsSection
      data={[
        ...tests.map((_, index) => ({
          menuItem: `Test ${index + 1}`,
          render: () => (
            <NamePrefixModifier appendNamePrefix={`EmbeddedTests.Tests[${index}].Data.HandShearVane`}>
              <McvEmbeddedHandShearVaneWorksheet />
            </NamePrefixModifier>
          ),
        })),
        { menuItem: 'Results', render: () => <HandShearVaneResultsSection /> },
      ]}
    ></TabsSection>
  );
};

HandShearVaneTabsSection = withInjectedProps(HandShearVaneTabsSection);

export { HandShearVaneTabsSection };
export default HandShearVaneTabsSection;
